import { XCircleIcon } from "@heroicons/react/20/solid";

const AlertRed = ({ title, message, onRetry, retryLabel = "Try again" }) => {
  return (
    <div className="rounded-card bg-signal-red-50 border border-signal-red-100 border-l-4 border-l-signal-red-500 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon aria-hidden="true" className="h-5 w-5 text-signal-red-500" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-signal-red-700">{title}</h3>
          <div className="mt-1 text-sm text-signal-red-700/90">
            <p>{message}</p>
          </div>
          {onRetry && (
            <div className="mt-3">
              <button
                type="button"
                onClick={onRetry}
                className="rounded-pill bg-white border border-signal-red-100 px-3 py-1.5 text-sm font-medium text-signal-red-700 hover:bg-signal-red-50 focus:outline-none focus:ring-2 focus:ring-signal-red-500/30"
              >
                {retryLabel}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertRed;
